import React, { useState, useEffect } from 'react';


function Admin() {

    const SERVER_API = "https://bell-project-backend.fly.dev"
    
    const [count_of_blocks, set_count_of_blocks] = useState()
    const [addFormData, setAddFormData] = useState({
        numer_id: "",
        image: "",
        header: "",
        paragraf: ""
    });

    const [uploadFormData, setUploadFormData] = useState({
        numer_id: "",
        image: "",
        header: "",
        paragraf: ""
    });

    const [uploadHeaderFormData, setUploadHeaderFormData] = useState("");
    const [deleteHeaderFormData, setDeleteHeaderFormData] = useState("");




    const addHandleChange = (e) => {
        setAddFormData({
            ...addFormData,
            [e.target.name]: e.target.value
        });
    };

    const addHandleImageChange = (e) => {
        const file = e.target.files[0]; // Отримуємо файл
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file); // Конвертуємо в Base64
            reader.onloadend = () => {
                setAddFormData((prev) => ({ ...prev, image: reader.result }));
            };
        }
    };

    const addHandleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            const response = await fetch(`${SERVER_API}/blogs/add_block`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(addFormData),
            });

            if (!response.ok) throw new Error("Помилка при відправці");
            alert("Блок додано успішно!");
        } catch (error) {
            console.error("Помилка:", error);
        }
    };




    const uploadHeaderHandleChange = (e) => {
        setUploadHeaderFormData(e.target.value)
    };

    const uploadHandleChange = (e) => {
        setUploadFormData({
            ...uploadHeaderFormData,
            [e.target.name]: e.target.value
        });
    };

    const uploadHandleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file); // Конвертуємо в Base64
            reader.onloadend = () => {
                setUploadFormData((prev) => ({ ...prev, image: reader.result }));
            };
        }
    };

    const uploadHandleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            const response = await fetch(`${SERVER_API}/blogs/block_update/${uploadHeaderFormData}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(uploadFormData),
            });

            if (!response.ok) throw new Error("Помилка при відправці");
            alert("Блок редаговано успішно!");
        } catch (error) {
            console.error("Помилка:", error);
        }
    };



    const deleteHeaderHandleChange = async (e) => {
        setDeleteHeaderFormData(e.target.value);
    };

    const deleteHandleSubmit = async (e) => {
        e.preventDefault();
        console.log("Дані для видалення:", deleteHeaderFormData);
        try {
            const response = await fetch(`${SERVER_API}/blogs/block_delete_by_str/${encodeURIComponent(deleteHeaderFormData).replace(/%20/g, "+")}`, {
                method: "DELETE"
            });
    
            if (!response.ok) throw new Error("Помилка при видаленні блоку");
    
            console.log("Блок успішно видалено!");
        } catch (error) {
            console.error("Помилка:", error);
        }
    };





    const get_count_of_blocks = async () => {
        try {
          const res = await fetch(`${SERVER_API}/blogs/last_numer_id`);
          const data = await res.json();
          set_count_of_blocks(data.last_numer_id);
        } catch (error) {
          console.error("Помилка при отриманні даних:", error);
        }
      };


      useEffect(() => {
        get_count_of_blocks();
      });

    return(
        <div className='admin_body'>
            <h1>Admin</h1>
            <section className='blog'>
                <h2>Блог</h2>
                <h2>Кількість блоків: {count_of_blocks}</h2>
                <div>
                    <h3>Додати блок</h3>
                    <form id="add-form" onSubmit={addHandleSubmit}>
                        <label htmlFor="numer-id-upload">Номер</label>
                        <input type="text" id="numer-id-upload" name="numer_id" value={addFormData.numer_id} onChange={addHandleChange} />

                        <label htmlFor="header-upload">Назва</label>
                        <input type="text" id="header-upload" name="header" value={addFormData.header} onChange={addHandleChange} />

                        <label htmlFor="paragraf-upload">Текст</label>
                        <input type="text" id="paragraf-upload" name="paragraf" value={addFormData.paragraf} onChange={addHandleChange} />

                        <label htmlFor="image-upload">Зображення</label>
                        <input type="file" id="image-upload" accept="image/*" onChange={addHandleImageChange} />

                        <button type="submit">Додати блок</button>
                    </form>
                </div>
                <div>
                    <h3>Редагувати блок за назвою</h3>
                    
                    <form id="upload-form" onSubmit={uploadHandleSubmit}>
                        <label htmlFor="search-header-upload">Назва</label>
                        <input type="text" id="search-header-upload" name="search-header" value={uploadHeaderFormData} onChange={uploadHeaderHandleChange}/>

                        <label htmlFor="numer-id-upload">Номер</label>
                        <input type="text" id="numer-id-upload" name="numer_id" value={uploadFormData.numer_id} onChange={uploadHandleChange} />

                        <label htmlFor="header-upload">Назва</label>
                        <input type="text" id="header-upload" name="header" value={uploadFormData.header} onChange={uploadHandleChange} />

                        <label htmlFor="paragraf-upload">Текст</label>
                        <input type="text" id="paragraf-upload" name="paragraf" value={uploadFormData.paragraf} onChange={uploadHandleChange} />

                        <label htmlFor="image-upload">Зображення</label>
                        <input type="file" id="image-upload" accept="image/*" onChange={uploadHandleImageChange} />

                        <button type="submit">Змінити блок</button>
                    </form>
                </div>
                <div>
                    <h3>Видалити блок за назвою</h3>
                    
                    <form id="delete-form" onSubmit={deleteHandleSubmit}>
                        <label htmlFor="search-header-upload">Назва</label>
                        <input type="text" id="search-header-upload" name="search-header" value={deleteHeaderFormData} onChange={deleteHeaderHandleChange}/>

                        <button type="submit">Видалити блок</button>
                    </form>
                </div>
            </section>
        </div>
        
    );
}

export default Admin;